<template>
  <a-spin size="large" :spinning="loading">
    <div class="home">
      <div class="wrap-step">
        <Step
          :current="$route.query.isfromCamp == 1 ? 3 : 2"
          :isfromCamp="$route.query.isfromCamp == 1 ? true : false"
        ></Step>
      </div>
      <div class="wrap-pay">
        <div class="binfo">
          <span :class="[lang]">{{ $t("EnterPaymentDetails") }}</span
          ><a-button v-if="havAccount == 2" @click="havAccount = 1">{{
            $t("Cancel")
          }}</a-button>
        </div>
        <div class="form-box" style="padding-top: 30px">
          <a-form :form="form" class="form" formLayout="vertical">
            <template>
              <div id="card-container"></div>
              <div
                style="color: #ff4e3a; padding-top: 16px"
                class="error"
                v-if="errorInfo"
              >
                {{ errorInfo }}
              </div>
              <!-- <div id="link-authentication-element" />
              <div id="payment-element" /> -->
            </template>
          </a-form>
          <!-- <a-form :form="form" class="form" formLayout="vertical">
            <template>
              <div id="card-container">
                <a-row>
                  <a-col :span="24">
                    <a-form-item
                      class="cardItem"
                      :class="[lang]"
                      :label="$t('CardNumber')"
                    >
                      <div id="card-number-element" />
                      <p
                        v-if="errors.cardNumber"
                        :style="{ color: 'red' }"
                        class="error"
                      >
                        {{ errors.cardNumber }}
                      </p>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="12">
                    <a-form-item
                      class="cardItem pr"
                      :label="$t('ExpirationDate')"
                    >
                      <div id="expiry-element" />
                      <p v-if="errors.expiry" :style="{ color: 'red' }">
                        {{ errors.expiry }}
                      </p>
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      class="cardItem pl"
                      :class="[lang]"
                      :label="$t('SecurityCode')"
                    >
                      <div id="cvc-element" />
                      <p v-if="errors.cvc" :style="{ color: 'red' }">
                        {{ errors.cvc }}
                      </p>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
            </template>
          </a-form> -->
        </div>
        <div class="tit">{{ $t("Order") }}</div>
        <ul v-if="$route.query.discount_code">
          <li>
            <div class="label">{{ $t("OriginalPrice") }}</div>
            <div class="cont">
              ${{ parseFloat($route.query.original_price).toFixed(2) }}
            </div>
          </li>
          <li>
            <div class="label">{{ $t("Discount") }}</div>
            <div class="cont">
              - ${{ parseFloat($route.query.discount_price).toFixed(2) }}
            </div>
          </li>
          <li>
            <div class="label">{{ $t("TotalPrice") }}</div>
            <div class="cont money">
              ${{ parseFloat($route.query.price).toFixed(2) }}
            </div>
          </li>
        </ul>
        <ul v-else>
          <li>
            <div class="label">{{ $t("OriginalPrice") }}</div>
            <div class="cont">
              ${{ parseFloat($route.query.original_price).toFixed(2) }}
            </div>
          </li>
          <!-- <li>
          <div class="label">Referral Discount</div>
          <div class="cont">- $0.0</div>
        </li> -->
          <li>
            <div class="label" :class="[lang]">{{ $t("TotalPrice") }}</div>
            <div class="cont money">
              ${{ parseFloat($route.query.price).toFixed(2) }}
            </div>
          </li>
        </ul>
        <div class="Aftertrialends" v-if="$route.query.type == 4">
          {{ $t("Aftertrialends") }}
        </div>
        <div class="baozhang">
          <p class="t1">
            <a-icon type="safety-certificate" class="icon" />
            {{ $t("fourMoth")
            }}<a-tooltip placement="bottom" overlayClassName="customTip">
              <template slot="title">
                <p style="font-size: 12px">
                  {{ $t("Termsandconditionsapply") }}<br />
                  • {{ $t("Aleast10campaigns") }} <br />
                  • {{ $t("Atleasttwocampaigns") }}
                  <br />
                  • {{ $t("Noleadsweregenerated") }}
                  <br />
                  • {{ $t("Thispolicyapplies") }}
                </p>
              </template>
              <span
                ><a-icon
                  type="exclamation-circle"
                  style="color: #fff; margin-left: 5px"
                />
              </span>
            </a-tooltip>
            <!-- {{ $t("Guarantee") }} -->
          </p>
          <p class="t2" v-html="formatEmail2()"></p>
        </div>
        <div class="buttons">
          <a-button size="large" @click="back" class="btn">{{
            $t("Back")
          }}</a-button>
          <a-button
            size="large"
            id="confirm"
            @click="triggerConfirm"
            class="btn"
            type="primary"
            >{{
              $route.query.type == 4 ? $t("Bindcard") : $t("Purchase")
            }}</a-button
          >
        </div>
      </div>
    </div>
    <LeaveupDialog
      @callback="callback"
      @goPay="triggerConfirm"
      ref="leaveDialog"
    ></LeaveupDialog>
  </a-spin>
</template>

<script>
import dayjs from "dayjs";
import LeaveupDialog from "./components/leaveupDialog";
import { loadStripe } from "@stripe/stripe-js";
import Step from "./Step.vue";

export default {
  data() {
    return {
      havAccount: 0,
      codeShow: false,
      form: this.$form.createForm(this),
      cardList: [],
      discountInfo: null,
      errorinfo: "",
      loading: true,
      payed: false,
      orderInfo: {},
      toPath: null,
      errors: {},
      errorInfo: null,
      stripe: null,
      elements: null,
      card: null,
      client_secret: null,
    };
  },
  i18n: require("../i18n"),
  created() {
    this.getLocationList();
    // this.getCardList();
  },
  components: { LeaveupDialog, Step },
  mounted() {
    this.init();
    // this.splitRender();
    // this.saveHandler();
  },

  beforeRouteLeave(to, from, next) {
    next();
    // this.toPath = to;
    // if (!this.payed) {
    //   this.$refs["leaveDialog"].showPayGuide = true;
    // } else {
    //   next();
    // }
  },
  methods: {
    formatEmail2() {
      return this.$t("Notsatisfied").replace(
        "info@strategybrain.com",
        '<a style="color:#fff" href="mailto:info@strategybrain.com">info@strategybrain.com</a>',
      );
    },
    callback() {
      this.payed = true;
      this.$router.push({
        path: this.toPath.fullPath,
      });
    },
    handleStripeChange(event) {
      // 清除之前的错误信息
      this.errors = {};
      // 如果有错误，记录下来
      if (event.error) {
        this.errorInfo = event.error.message;
      } else {
        this.errorInfo = null;
      }
    },
    async init() {
      {
        let key =
          "pk_live_51Q7vAIP8FI9vKFZnfgib7NtnsK8NSMwW8ltWKidmNYvDqciV32iTqCOZtE2IPdtAGmchynjSo5u4HMdBHbJhnVBC00ZDKkeuOV";
        let mode = process.env.VUE_APP_PAY_MOD;
        if (mode == "demo") {
          key =
            "pk_test_51Q7vAIP8FI9vKFZnfU62HjMmvALuwG7tbBLks1bvnpQdVpf5MLsCjUdHFH9yQmUBkkqp3i9MxpaR86m58mhtr6vv00BosxzGTQ";
        }
        this.stripe = await loadStripe(key, {
          locale: this.lang == "AR" ? "ar" : this.lang == "CN" ? "zh" : "en",
        });
        let clientSecret = this.$route.query.client_secret;
        this.elements = this.stripe.elements({
          clientSecret: this.client_secret ? this.client_secret : clientSecret,
        });
        this.card = this.elements.create("card", {
          style: {
            base: {
              color: "#32325d",
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: "antialiased",
              fontSize: "16px",
              "::placeholder": {
                color: "#aab7c4",
              },
            },
            invalid: {
              color: "#fa755a",
              iconColor: "#fa755a",
            },
          },
        });
        this.card.on("change", this.handleStripeChange);
        this.card.mount("#card-container");
        this.card.on("ready", this.onReady);
      }
    },
    async triggerConfirm() {
      this.loading = true;
      // if (this.$route.query.type == 4) {
      //   try {
      //     // 创建支付方式
      //     const result = await this.stripe.createPaymentMethod({
      //       type: "card",
      //       card: this.card,
      //     });

      //     if (result.error) {
      //       // 显示错误信息
      //       // const errorElement = document.getElementById("card-errors");
      //       // errorElement.textContent = result.error.message;

      //       this.loading = false;
      //       this.errorInfo = result.error.message;
      //       return;
      //     } else {
      //       console.log(result.paymentMethod.id);

      //       let { new_order_id, campaign_type, upgrade_free, originUrl, type } =
      //         this.$route.query;
      //       if (type == 4) {
      //         this.getUserInfo();
      //         if (upgrade_free == 1) {
      //           this.getUserInfo().then(() => {
      //             this.loading = false;
      //             if (originUrl) {
      //               this.$router.replace({
      //                 path: originUrl,
      //               });
      //             } else {
      //               if (campaign_type == 1) {
      //                 this.$router.replace({
      //                   path: "/sales/salesReps/home",
      //                 });
      //               } else {
      //                 this.$router.replace({
      //                   path: "/hr/recruiter/home",
      //                 });
      //               }
      //             }
      //           });
      //         } else {
      //           this.loading = false;
      //           this.$router.replace({
      //             path: "/setting/bindAccount",
      //             query: { id: new_order_id, campaign_type },
      //           });
      //         }
      //         return;
      //       }
      //       // 将 paymentMethod ID 发送到服务器
      //       // const response = await fetch("/save-payment-method", {
      //       //   method: "POST",
      //       //   headers: {
      //       //     "Content-Type": "application/json",
      //       //   },
      //       //   body: JSON.stringify({
      //       //     paymentMethodId: result.paymentMethod.id,
      //       //   }),
      //       // });

      //       // const responseData = await response.json();

      //       // if (responseData.success) {
      //       //   // 卡片绑定成功，可以更新 UI
      //       //   alert("卡片已成功绑定！");
      //       // } else {
      //       //   // 处理服务器端错误
      //       //   const errorElement = document.getElementById("card-errors");
      //       //   errorElement.textContent = responseData.error || "绑定卡片失败";
      //       // }
      //     }
      //   } catch (error) {
      //     console.error("错误:", error);
      //     this.errorInfo = "发生了网络错误，请重试";
      //   }
      //   return;
      // }

      try {
        this.writeLog("plan", "page_click", "purchase");
        let client_secret = this.client_secret
          ? this.client_secret
          : this.$route.query.client_secret;
        const setupResult = await this.stripe.confirmCardSetup(client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
              email: null,
            },
          },
        });
        if (setupResult.error) {
          this.loading = false;
          this.errorInfo = setupResult.error.message;
          return;
        } else {
          this.errorInfo = "";
        }

        let { new_order_id, campaign_type, upgrade_free, originUrl, type } =
          this.$route.query;
        if (type == 4) {
          this.getUserInfo();
          if (upgrade_free == 1) {
            this.getUserInfo().then(() => {
              this.loading = false;
              if (originUrl) {
                this.$router.replace({
                  path: originUrl,
                });
              } else {
                if (campaign_type == 1) {
                  this.$router.replace({
                    path: "/sales/salesReps/home",
                  });
                } else {
                  this.$router.replace({
                    path: "/hr/recruiter/home",
                  });
                }
              }
            });
          } else {
            this.loading = false;
            this.$router.replace({
              path: "/setting/bindAccount",
              query: { id: new_order_id, campaign_type },
            });
          }
          return;
        }
        this.$axios(
          "/payment/stripe_process",
          {
            setup_intent_id: setupResult.setupIntent.id,
            order_id: parseInt(this.$route.query.new_order_id),
          },
          "post",
        ).then((res) => {
          if (res.code == 200 && res.data.pay_result) {
            this.errorInfo = "";
            this.$message.success(res.msg);
            let { new_order_id, campaign_type, upgrade_free, originUrl } =
              this.$route.query;
            this.getUserInfo();
            if (upgrade_free == 1) {
              this.getUserInfo().then(() => {
                this.loading = false;
                if (originUrl) {
                  this.$router.replace({
                    path: originUrl,
                  });
                } else {
                  if (campaign_type == 1) {
                    this.$router.replace({
                      path: "/sales/salesReps/home",
                    });
                  } else {
                    this.$router.replace({
                      path: "/hr/recruiter/home",
                    });
                  }
                }
              });
            } else {
              this.loading = false;
              this.$router.replace({
                path: "/setting/bindAccount",
                query: { id: new_order_id, campaign_type },
              });
            }
          } else {
            this.loading = false;
            this.errorInfo = res.data.pay_msg;
            this.client_secret = res.data.client_secret;
          }
        });
      } catch (error) {
        console.error("Payment failed:", error);
        this.loading = false;
        //this.showErrorMessage(error.message);
      }
    },
    onReady() {
      this.loading = false;
    },

    // async triggerConfirm() {
    //   const cardNumElement = getElement("cardNumber");
    //   let { intent_id, client_secret, airwallex_customer_id } =
    //     this.$route.query;
    //   this.loading = true;
    //   createPaymentConsent({
    //     mode: "recurring",
    //     intent_id: intent_id, // intent id(Optional)
    //     customer_id: airwallex_customer_id, // customer id
    //     client_secret: client_secret, // client secret (from creating intent or generating client secret)
    //     currency: "USD", // currency
    //     element: cardNumElement, // either the card element or card number element depends on the element you integrate,
    //     next_triggered_by: "merchant", // 'merchant' for MIT and 'customer' for CIT
    //   })
    //     .then((response) => {
    //       console.log(response);
    //       if (response === false) {
    //         this.loading = false;
    //         return;
    //       }
    //       let { new_order_id, campaign_type, upgrade_free, originUrl } =
    //         this.$route.query;
    //       this.getUserInfo();
    //       this.$axios(
    //         "/payment/save_consents",
    //         {
    //           consents_id: response.payment_consent_id,
    //           order_id: parseInt(new_order_id),
    //         },
    //         "post"
    //       );
    //       if (upgrade_free == 1) {
    //         this.getUserInfo().then(() => {
    //           this.loading = false;
    //           if (originUrl) {
    //             this.$router.replace({
    //               path: originUrl,
    //             });
    //           } else {
    //             this.$router.replace({
    //               path: "/sales/salesReps/home",
    //             });
    //           }
    //         });
    //       } else {
    //         this.loading = false;
    //         this.$router.replace({
    //           path: "/setting/bindAccount",
    //           query: { id: new_order_id, campaign_type },
    //         });
    //       }
    //     })
    //     // STEP #6c: Listen to errors
    //     .catch((error) => {
    //       this.loading = false;
    //       /**
    //        * ... Handle event on error
    //        */
    //       this.$message.error(error.message);
    //     });
    // },
    back() {
      this.writeLog("plan", "page_click", "back");
      this.$router.go(-1);
    },
    getCardList() {
      this.$axios("/payment/credit_card_list", {}, "post").then((res) => {
        if (res.code == 200) {
          this.cardList = res.data || [];
          if (res.data && res.data.length > 0) {
            this.havAccount = 1;
          }
        }
      });
    },

    validDiscountCode($event) {
      if (
        !$event.target.value ||
        ($event.target.value && !$event.target.value.trim())
      ) {
        this.discountInfo = null;
        this.errorinfo = null;
        return;
      }
      this.$axios(
        "/payment/discount_code_check",
        {
          discount_code: $event.target.value.trim(),
          subscription_plan_id: parseInt(this.$route.query.id),
        },
        "post",
      ).then((res) => {
        if (res.code == 200) {
          this.discountInfo = res.data;
        } else {
          this.errorinfo = res.msg;
        }
      });
    },
    showCode() {
      this.codeShow = true;
    },
    addNew() {
      this.havAccount = 2;
      this.discountInfo = null;
    },
    getDate() {
      return dayjs(Date.now()).format("YYYY-MM-DD");
    },
    validDate() {},
  },
};
</script>
<style lang="less">
.customTip {
  .ant-tooltip-inner {
    background-color: #e4f5de !important;
    p {
      color: #e2dcdc;
    }
  }
}
</style>
<style lang="less" scoped>
.home {
  margin-top: 50px;
  padding: 0px 30px 20px 30px;
}
.baozhang {
  border-radius: 10px;
  background-color: #0e756a;
  padding: 12px;
  color: #fff;
  margin: 20px 0;
  .t1 {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .icon {
      font-size: 30px;
      color: #fff;
      margin-right: 6px;
    }
  }
  .t2 {
    margin-bottom: 0;
  }
  a {
    color: #fff !important;
  }
}
.wrap-step {
  padding-top: 53px;
  margin: 0 auto;
  width: 800px;
  /deep/.ant-steps-item-title::after {
    background-color: #e1e1e1;
    height: 2px;
  }
  /deep/.ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #e1e1e1;
  }
  /deep/.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #e1e1e1;
  }
}
.discode {
  font-weight: 400;
  font-size: 14px;
  color: #0e756a;
  cursor: pointer;
  .icon {
  }
}
.wrap-pay {
  width: 930px;
  margin: 0 auto;
  margin-top: 28px;
  padding: 40px;
  background: #ffffff;
  border-radius: 4px;
  .tit {
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    margin-bottom: 10px;
    text-align: left;
    margin-top: 40px;
    // border-top: #e5e5e5 solid 1px;
  }
  ul li {
    height: 41px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .label,
    .cont {
      height: 41px;
      line-height: 41px;
    }
    .cont {
      text-align: right;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }
    .label {
      font-weight: bold;
      font-size: 20px;
      color: #666666;
    }
    .money {
      color: #0e756a;
      font-size: 30px;
    }
  }
}
.binfo {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  // padding-top: 40px;
  // margin-bottom: 30px;
  // border-top: #e5e5e5 solid 1px;
  display: flex;
  justify-content: space-between;
}
.pr {
  padding-right: 45px;
}
.pl {
  padding-left: 45px;
}
.buttons {
  text-align: center;
  margin-top: 30px;
  .btn {
    min-width: 200px;
    margin-left: 20px;
  }
}
.addNew {
  width: 144px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 2px solid #0e756a;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.errorInfo {
  color: #ff4e3a;
  margin-bottom: 0;
}
.discountTips {
  font-weight: 400;
  font-size: 14px;
  color: #ffb175;
}
.field-container {
  margin: 0 auto 16px;
  width: 300px;
}
.field-container div {
  border: 1px solid;
  padding: 4px 8px;
  margin-top: 8px;
}
div.field-label {
  text-align: left;
  border: 0;
}
.cardItem {
  margin-bottom: 0;
}
/* Custom styling for the inputs */
#cardNumber,
#cvc,
#expiry {
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  padding: 5px 10px;
  margin-top: 8px;
  height: 28px;
  box-sizing: content-box;
}

/* 在你的 CSS 文件中 */
.StripeElement {
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
  box-sizing: border-box;
}

.StripeElement--focus {
  border-color: #6a737d;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.Aftertrialends {
  height: 24px;
  font-size: 14px;
  color: #6a737d;
}
</style>
